var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"disabled":_vm.disabled
      ? true
      : _vm.value.isOk != null
      ? false
      : _vm.value.loading || !_vm.value.clickable,"block":"","loading":_vm.value.loading,"color":_vm.colorState},on:{"click":_vm.emitEvent}},[(_vm.hasIcon)?_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("save")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.textState)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }